import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenis = null;
let tickerFn = null;

export function initLenis() {
    if (typeof window === 'undefined' || lenis) return lenis;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return null;

    lenis = new Lenis({
        // heavier, viscous "weighted" feel — low lerp = slow to catch up to the target
        lerp: 0.08,
        wheelMultiplier: 1.2,
        touchMultiplier: 1,
        smoothWheel: true,
        syncTouch: false,
        gestureOrientation: 'vertical',
        infinite: false,
    });

    lenis.on('scroll', ScrollTrigger.update);

    tickerFn = (time) => {
        lenis.raf(time * 1000);
    };
    gsap.ticker.add(tickerFn);
    gsap.ticker.lagSmoothing(0);

    return lenis;
}

export function getLenis() {
    return lenis;
}

export function destroyLenis() {
    if (tickerFn) {
        gsap.ticker.remove(tickerFn);
        tickerFn = null;
    }
    if (lenis) {
        lenis.destroy();
        lenis = null;
    }
}
